/**
 * Email validator
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get METACHARACTERS () {
        return METACHARACTERS;
    },
    get emailValidator () {
        return emailValidator;
    }
});
const emailValidator = (email)=>{
    const emailRegex = /^[A-Za-z0-9._%+-/,]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,255}$/;
    return emailRegex.test(email);
};
const METACHARACTERS = /^[[\]{}()*+?.\\^$|=\-@]/;
